import { useApp } from '../store.js';

/** Сохранённый вызов друга (пришёл во время турнира) — принять, когда игрок свободен. */
export function PendingInvite() {
  const code = useApp((s) => s.pendingInvite);
  const accept = useApp((s) => s.acceptInvite);
  const joining = useApp((s) => s.joining);
  if (!code) return null;
  return (
    <button
      type="button"
      className="play play--small play--invite"
      disabled={joining}
      onClick={() => void accept(code)}
    >
      ⚔️ Принять вызов друга
    </button>
  );
}
